var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSimulatorArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220,80.2V36h-44.2v17H80.2V36H36v44.2h17.6v95.6H36V220h44.2v-17.3l95.6-43.1V176H220v-44.2h-17.6V80.2 H220z M46.6,69.7V46.6h23.1v23.1H46.6z M69.7,209.4H46.6v-23.1h23.1V209.4z M175.8,148.8l-95.6,43.1v-16.1H64.1V80.2h16.1V63.5 h95.6v16.7h16.1v51.6h-16.1V148.8z M209.4,142.3v23.1h-23.1v-23.1H209.4z M186.3,69.7V46.6h23.1v23.1H186.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.5,10.5 96.3,10.5 96.3,0 10.5,0 0,0 0,10.5 0,96.3 10.5,96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.5,0 159.7,0 159.7,10.5 245.5,10.5 245.5,96.3 256,96.3 256,10.5 256,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.5,245.5 159.7,245.5 159.7,256 245.5,256 256,256 256,245.5 256,159.7 245.5,159.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.5,159.7 0,159.7 0,245.5 0,256 10.5,256 96.3,256 96.3,245.5 10.5,245.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSimulatorArea);
export default __webpack_public_path__ + "static/media/icon-simulator-area.d14d2ebd.svg";
export { ForwardRef as ReactComponent };